import type { Framework } from '@toeverything/infra';

import { WorkspaceDBService } from '../db';
import { DocsService } from '../doc';
import { I18nService } from '../i18n';
import { WorkspaceScope } from '../workspace';
import { TemplateDocList } from './entities/list';
import { TemplateDocSetting } from './entities/setting';
import { TemplateDocService } from './services/template-doc';
import { TemplateDocListStore } from './store/list';
import { TemplateDocSettingStore } from './store/setting';

export { TemplateDocService };
export {
  createMeetingEntryTemplate,
  createMeetingsTemplate,
  ensureMeetingsTemplates,
} from './templates/meetings-template';

export const configureTemplateDocModule = (framework: Framework) => {
  framework
    .scope(WorkspaceScope)
    .service(TemplateDocService, [DocsService, I18nService])
    .store(TemplateDocListStore, [WorkspaceDBService])
    .entity(TemplateDocList, [TemplateDocListStore, DocsService])
    .store(TemplateDocSettingStore, [WorkspaceDBService])
    .entity(TemplateDocSetting, [TemplateDocSettingStore]);
};
